import React from "react";
import { Accordion } from "react-bootstrap";
import { faqs } from "../../Data/faq";
import StyledComponents from "../Styled/Components";
import { v4 as uuidv4 } from "uuid";
const AccordionItem = () => {
  const generalFilter = (item) => {
    return item.category.toLowerCase() === "general";
  };
  const tailoringFilter = (item) => {
    return item.category.toLowerCase() === "tailoring";
  };
  const laundryFilter = (item) => {
    return item.category.toLowerCase() === "laundry";
  };
  const categories = ["General", "Tailoring", "Laundry"];

  const filters = [generalFilter, tailoringFilter, laundryFilter];

  const { StyledParagraph } = StyledComponents;

  return (
    <>
      <div className="grid gap-5 mt-5">
        {categories.map((category, idx) => (
          <div key={idx} className={`${idx !== 0 && "mt-5"}`}>
            <StyledParagraph className="">{category}</StyledParagraph>
            {faqs.filter(filters[idx]).map((faq, id) => (
              <Accordion.Item
                key={id}
                eventKey={uuidv4()}
              >
                <Accordion.Header>{faq.title}</Accordion.Header>
                <Accordion.Body>{faq.content}</Accordion.Body>
              </Accordion.Item>
            ))}
          </div>
        ))}
      </div>
    </>
  );
};

export default AccordionItem;
